import { DatePicker } from 'antd';
import dayjs from 'dayjs';
import React from 'react';

function AntdDatePicker({
    label,
    name,
    className,
    required,
    value,
    disabled,
    onChange,
    uppercase,
    allowClear,
    needConfirm,
    readOnly,
    description,
    minDate,
    maxDate,
    error,
    format,
    showTime,
    showSecond,
    renderExtraFooter,
    size,
    placement
  }) {
  return (
    <div className={`${className ?? ''} inputBox w-full text-xs tracking-tight space-y-1`}>
      {!readOnly && (
        <DatePicker
          use12Hours={showTime}
          showTime={showTime}
          format={format ?? 'MMM DD, YYYY'}
          needConfirm={needConfirm ?? false}
          allowClear={!readOnly && allowClear}
          id={name}
          showSecond={showSecond}
          inputReadOnly
          readOnly={readOnly}
          minDate={minDate}
          maxDate={maxDate}
          disabled={disabled}
          renderExtraFooter={renderExtraFooter}
          className={`${uppercase ? 'uppercase' : ''} h-14 inputField disabled:bg-gray-100 disabled:text-gray-400 disabled:cursor-not-allowed placeholder-gray-400 text-gray-900 text-base rounded-md p-3 w-full appearance-none focus:ring-1 focus:ring-accent border ${error ? 'border-red-500' : 'border-gray-200'} focus:border-accent outline-none focus:outline-none transition ease-in-out duration-500`}
          value={value ? dayjs(value) : null}
          onChange={onChange}
          size={size}
          placement={placement}
        />
      )}
      {readOnly && (
        <p className={`${uppercase ? 'uppercase' : ''} inputField text-md my-2`}>{value ? dayjs(value).format(format ?? 'MMM DD, YYYY') : ''}</p>
      )}
      <span className={`${uppercase ? 'uppercase' : ''} inputLabel inputLabel-raised text-sm`}>{label}{required && <span className="text-red-500 ml-1">*</span>}</span>
      {description && <div className="text-xs ml-2 font-light text-gray-500">{description}</div>}
      {error && <div className="text-sm ml-2 font-light text-red-500">{error}</div>}
    </div>
  );
}

export default AntdDatePicker
